
export const UPLOAD_FOLDER_NAME = 'lobby';

export const UPLOAD_FOLDER_FILE_TAG_NAME = 'upload';
